import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7be445a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup-page" }
const _hoisted_2 = { class: "signup-page__wrapper" }

import { useI18n } from 'vue-i18n'

import AppMeta from '@C/common/AppMeta.vue'
import SignupFormSection from '@C/pages/signup/SignupForm/SignupFormSection.vue'
import SignupIntro from '@C/pages/signup/SignupIntro/SignupIntro.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewSignup',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(AppMeta, {
      title: _unref(t)('common.pageTitles.signup')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SignupFormSection),
      _createVNode(SignupIntro)
    ])
  ]))
}
}

})